import {Locale} from '@dms/api/base';

export type ReadCodelistsApiResponse = /** status 200  */ CodelistOverviewResponseBody[];
export type ReadCodelistsApiArg = unknown;
export type ReadCodelistApiResponse = /** status 200  */ CodelistResponseBody;
export type ReadCodelistApiArg = {
  codelistId: string;
};
export type AddCodeApiResponse = /** status 201  */ CodeResponseBody;
export type AddCodeApiArg = {
  codelistId: string;
  addCodeRequestBody: AddCodeRequestBody;
};
export type ReadCodeApiResponse = /** status 200  */ CodeResponseBody;
export type ReadCodeApiArg = {
  codelistId: string;
  codeId: string;
};
export type RemoveCodeApiResponse = unknown;
export type RemoveCodeApiArg = {
  codelistId: string;
  codeId: string;
};
export type RenameCodeApiResponse = unknown;
export type RenameCodeApiArg = {
  codelistId: string;
  codeId: string;
  renameCodeRequestBody: RenameCodeRequestBody;
};
export type ChangeCodePriorityApiResponse = unknown;
export type ChangeCodePriorityApiArg = {
  codelistId: string;
  codeId: string;
  changeCodePriorityRequestBody: ChangeCodePriorityRequestBody;
};
export type CodelistOverviewResponseBody = {
  codelistId: string;
  name: string;
};
export type LocalizedName = {
  locale: Locale;
  name: string;
};
export type CodeResponseBody = {
  codeId: string;
  name: string;
  priority: number;
  isDisabled: boolean;
  localizedNames?: LocalizedName[];
};
export type CodelistResponseBody = {
  codelistId: string;
  name: string;
  codes: CodeResponseBody[];
};
export type AddCodeRequestBody = {
  name: string;
  priority: number;
};
export type RenameCodeRequestBody = {
  name: string;
};
export type ChangeCodePriorityRequestBody = {
  priority: number;
};

export type ChangeOrderOfCodesApiArg = {
  codelistId: string;
  changeOrderOfCodesRequestBody: ChangeOrderOfCodesRequestBody;
};
export type ChangeOrderOfCodesRequestBody = {
  codeIds: string[];
};

export type SetCodeLocalizedNameRequestBody = {
  locale: Locale;
  name: string;
};
export type SetCodeLocalizedNameApiResponse = unknown;
export type SetCodeLocalizedNameApiArg = {
  codelistId: string;
  codeId: string;
  setCodeLocalizedNameRequestBody: SetCodeLocalizedNameRequestBody;
};

export type RemoveCodeLocalizedNameApiResponse = unknown;
export type RemoveCodeLocalizedNameApiArg = {
  codelistId: string;
  codeId: string;
  locale: Locale;
};
